/* eslint-disable react-hooks/exhaustive-deps */
import { BookingProvider, DateInMilliSec, Path } from "@common/constans";
import { IGResponse, IOriginDestinationRequest, TripType } from "@common/models";
import { ICity, ICmsFeaturedFlight, ICmsRoute, IMedia, IWeekSchedule } from "@common/models/CMS";
import { Culture } from "@core/index";
import { IAppState } from "@misc/State";
import Config from "@service/Config";
import { useApolloQuery } from "@service/graphql";
import { FEATURED_FLIGHT } from "@service/graphql/query/Query.FeaturedFlight";
import Translate from "@service/Translate";
import { FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { createUrlSearchParams, fetchAvailabilityRequest, initAvailabilityRequest } from "./flightSearch/FlightSearch";
import { Card, CardAction, CardHeader, CardMedia } from "./general/card";
import Button from "./general/form/Button";
import DropDown from "./general/form/DropDown";
import Modal from "./general/Modal";
import Title from "./general/Title";
import WeeklyFlightAvailability from "./general/WeeklyFlightAvailability";

interface IFeaturedFlightsProps {
    className?: string;
}

const FeaturedFlights: FC<IFeaturedFlightsProps> = ({ className }) => {
    const { tr } = Translate;
    const { push } = useHistory();
    const { small, large, medium } = Config.get("viewport");
    const [featuredFlights, setFeaturedFlights] = useState<ICmsRoute[]>([]);
    const { data: featuredFlight } = useApolloQuery<IGResponse<ICmsFeaturedFlight[]>>(FEATURED_FLIGHT);
    const [featuredFlightBaseCities, setfeaturedFlightBaseCities] = useState<ICity[]>([]);
    const baseCityCodedefault = "THR"
    const [baseCityCode, setBaseCityCode] = useState<string>(baseCityCodedefault);
    const [featuredFlightVisibility, setFeaturedFlightVisibility] = useState<boolean>(false);
    const [featuredFlightIndex, setFeaturedFlightIndex] = useState<number>(0);
    const { airports, availabilityRequest, width } = useSelector((state: IAppState) => ({
        availabilityRequest: state.availabilityRequest,
        airports: state.airports,
        width: state.windowWidth
    }));
    let featuredRoutes: ICmsRoute[] = featuredFlight?.featuredFlight.find(x => x.baseCity?.contentItems[0].code?.code === baseCityCode)?.routes?.contentItems || [];

    useEffect(() => {
        if (baseCityCode && airports.length && featuredFlight?.featuredFlight.length) {
            setfeaturedFlightBaseCities(featuredFlight?.featuredFlight.map(x => x.baseCity?.contentItems[0] || {}) || []);
            featuredRoutes = featuredFlight?.featuredFlight.find(x => x.baseCity?.contentItems[0].code?.code === baseCityCode)?.routes?.contentItems || [];
            let featuredFlights: ICmsRoute[] = [];
            const processedRoutes: ICmsRoute[] = [];

            featuredRoutes?.forEach(route => {
                if (!processedRoutes.includes(route)) {
                    const originCode = route.code?.code.split("-")[0];
                    const destinationCode = route.code?.code.split("-")[1];
                    let orgAirport = airports.find(x => x.code === originCode);
                    let dstAirport = airports.find(x => x.code === destinationCode);
                    processedRoutes.push(route);
                    const roundTrip = checkRoundTrip(route);
                    if (roundTrip) {
                        processedRoutes.push(roundTrip);
                        if (dstAirport?.cityCode === baseCityCode) {
                            let temp = dstAirport;
                            dstAirport = orgAirport;
                            orgAirport = temp;
                        }
                    }
                    featuredFlights.push({ ...route });
                }
            });
            setFeaturedFlights(featuredFlights);
        }
    }, [featuredFlight, airports, baseCityCode])

    const checkRoundTrip = (route: ICmsRoute) => {
        const originCode = route.code?.code.split("-")[0];
        const destinationCode = route.code?.code.split("-")[1];
        return featuredRoutes.find(r => r.code?.code.split("-")[0] === destinationCode && r.code?.code.split("-")[1] === originCode);
    }

    const renderDisplayTitle = (route: ICmsRoute) => {
        const originCode = route.code?.code.split("-")[0];
        const destinationCode = route.code?.code.split("-")[1];
        const orgAirport = airports.find(x => x.code === originCode);
        const dstAirport = airports.find(x => x.code === destinationCode);
        return `${orgAirport?.cityName} - ${dstAirport?.cityName}` + (checkRoundTrip(route) ? ` - ${orgAirport?.cityName}` : '');
    }

    const onReserveClick = (featuredFlight: ICmsRoute) => {
        const odRequest: IOriginDestinationRequest = {
            originCode: featuredFlight.code?.code.split("-")[0],
            destinationCode: featuredFlight.code?.code.split("-")[1],
            departureDate: setFirstAvailableDate(featuredFlight.weekSchedule),
        }
        const roundTrip = checkRoundTrip(featuredFlight);
        if (roundTrip) {
            odRequest.arrivalDate = setFirstAvailableDate(roundTrip?.weekSchedule, odRequest.departureDate)
            availabilityRequest.tripType = TripType.RoundTrip;
        }
        availabilityRequest.originDestionations = [odRequest];
        initAvailabilityRequest(availabilityRequest);
        fetchAvailabilityRequest(availabilityRequest);
        if (Config.config.defaultBookingProvider === BookingProvider.Mahan)
            push(createUrlSearchParams(availabilityRequest));
    }

    const onDayAvailabilityClick = (departureDate: number, featuredFlight: ICmsRoute) => {
        const odRequest: IOriginDestinationRequest = {
            originCode: featuredFlight.code?.code.split("-")[0],
            destinationCode: featuredFlight.code?.code.split("-")[1],
            departureDate: departureDate,
        }
        const roundTrip = checkRoundTrip(featuredFlight);
        if (roundTrip) {
            odRequest.arrivalDate = setFirstAvailableDate(roundTrip.weekSchedule, departureDate);
            availabilityRequest.tripType = TripType.RoundTrip;
        }
        availabilityRequest.originDestionations = [odRequest];
        initAvailabilityRequest(availabilityRequest);
        fetchAvailabilityRequest(availabilityRequest);
        if (Config.config.defaultBookingProvider === BookingProvider.Mahan)
            push(createUrlSearchParams(availabilityRequest));
    }

    const onFeaturedFlightClickInDesktop = (index: number) => {
        if (width < medium) {
            setFeaturedFlightIndex(index)
            setFeaturedFlightVisibility(true);
        }
    }

    const first = featuredFlights[0] || {};

    return (
        <div className={`featured-flights ${className ?? ""}`}>
            {
                featuredFlights.length && featuredFlights.length <= 5 ?
                    <>
                        <header className="flex flex-center justify-between featured-flights-header">
                            <Title
                                text={tr("featured_flights_title")}
                                className="mb-0"
                            />
                            <div className="flex flex-center featured-flights-base-city-code">
                                <div className="title">{tr("from_origin")}</div>
                                <DropDown
                                    value={featuredFlightBaseCities.find(x => x.code?.code === baseCityCode)}
                                    dataSource={featuredFlightBaseCities}
                                    placeholder={tr("enter_origin")}
                                    valueKey="code"
                                    selectOptionsMode
                                    itemDisplayFormat="name"
                                    onChange={(name: string, value: any) => setBaseCityCode(value.code)}
                                    onBlur={(name: string, value: any) => !value && setBaseCityCode(baseCityCodedefault)}
                                />
                            </div>
                        </header>
                        <article className="featured-flights-article">
                            <div className="row flex">
                                {
                                    featuredFlights.length === 5 ?
                                        <div className="col-1-2 col-lg-1-3 col-sm-1-1 form-group featured-flights-aside-item" onClick={() => onFeaturedFlightClickInDesktop(0)}>
                                            <Card variant="vertical" >
                                                <CardMedia source={airports.find(x => x.code === first.code?.code.split("-")[1])?.cityCover || {} as IMedia} />
                                                <CardHeader>
                                                    <div className="row spa-0 flex justify-between">
                                                        <div className="col-1-auto col-lg-1-1 col-md-1-1 col-sm-1-1">
                                                            <h2 className="title">{renderDisplayTitle(first)}</h2>
                                                            <h4 className="sub-title">{friendlyWeekSchedule(first.weekSchedule)}</h4>
                                                        </div>
                                                        {
                                                            width > large ? <div className="col-1-auto col-lg-1-1 col-md-1-1 col-sm-1-1 flex">
                                                                <WeeklyFlightAvailability
                                                                    route={{
                                                                        origin: first.code?.code.split("-")[0],
                                                                        destination: first.code?.code.split("-")[1],
                                                                        weekSchedule: first.weekSchedule
                                                                    }}
                                                                    destinationVisiblity={false}
                                                                    onDayAvailabilityClick={(departureDate: number) => onDayAvailabilityClick(departureDate, first)}
                                                                />
                                                            </div>
                                                                : ""
                                                        }

                                                    </div>
                                                </CardHeader>
                                                {width > small && <CardAction>
                                                    <div className="row spa-1 flex flex-grow">
                                                        <div className="col-1-2 col-sm-1-1 mb-1">
                                                            <Button
                                                                text={tr("btn_reserve")}
                                                                height="35px"
                                                                variant="contained"
                                                                color="secondary"
                                                                onClick={() => onReserveClick(first)}
                                                            />
                                                        </div>
                                                        <div className="col-1-2 col-sm-1-1">
                                                            <Button
                                                                text={tr("trip_information")}
                                                                width="100%"
                                                                height="35px"
                                                                variant="outlined"
                                                                color="secondary"
                                                                url={`${Path.Destinations}/${first.code?.code.split("-")[1]}?baseCity=${baseCityCode}`}
                                                            />
                                                        </div>
                                                    </div>
                                                </CardAction>}
                                            </Card>
                                        </div>
                                        : ""
                                }

                                <div className={`${featuredFlights.length === 5 ? "col-1-2 col-lg-2-3" : "col-1-1 col-lg-1-1"} col-sm-1-1 featured-flights-main-items`}>
                                    <div className="row flex">
                                        {
                                            featuredFlights.slice(featuredFlights.length === 5 ? 1 : 0).map((featuredFlight, index) =>
                                                <div key={index} className={`${featuredFlights.length === 5 ? "col-1-2 col-md-1-1" : "col-1-3 col-md-1-2 show-featured-flight"} form-group col-sm-1-1 featured-flights-main-item`} onClick={() => onFeaturedFlightClickInDesktop(index + 1)}>
                                                    <Card variant="vertical">
                                                        <CardMedia source={airports.find(x => x.code === featuredFlight.code?.code.split("-")[1])?.cityCover || {} as IMedia} />
                                                        <CardHeader>
                                                            <div className="col-1-auto">
                                                                <h2 className="title">{renderDisplayTitle(featuredFlight)}</h2>
                                                                <h4 className="sub-title">{friendlyWeekSchedule(featuredFlight.weekSchedule)}</h4>
                                                            </div>
                                                        </CardHeader>
                                                        {width > small && <CardAction>
                                                            <div className="row spa-1 flex flex-grow">
                                                                {
                                                                    width > large ? <div className="col-1-1 mb-2">
                                                                        <WeeklyFlightAvailability
                                                                            route={{
                                                                                origin: featuredFlight.code?.code.split("-")[0],
                                                                                destination: featuredFlight.code?.code.split("-")[1],
                                                                                weekSchedule: featuredFlight.weekSchedule
                                                                            }}
                                                                            destinationVisiblity={false}
                                                                            onDayAvailabilityClick={(departureDate: number) => onDayAvailabilityClick(departureDate, featuredFlight)}
                                                                        />
                                                                    </div>
                                                                        : ""
                                                                }

                                                                <div className={`col-1-1 col-lg-1-2 col-md-1-2 col-sm-1-1 ${width > large || width <= small ? "mb-1" : ""}`}>
                                                                    <Button
                                                                        text={tr("btn_reserve")}
                                                                        height="35px"
                                                                        variant="contained"
                                                                        color="secondary"
                                                                        onClick={() => onReserveClick(featuredFlight)}
                                                                    />
                                                                </div>
                                                                <div className="col-1-1 col-lg-1-2 col-md-1-2 col-sm-1-1">
                                                                    <Button
                                                                        text={tr("trip_information")}
                                                                        height="35px"
                                                                        variant="outlined"
                                                                        color="secondary"
                                                                        url={`${Path.Destinations}/${featuredFlight.code?.code.split("-")[1]}?baseCity=${baseCityCode}`}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </CardAction>}
                                                    </Card>
                                                </div>
                                            )
                                        }
                                    </div>
                                </div>
                            </div>
                        </article>
                        <Modal
                            name="slide-up"
                            show={featuredFlightVisibility}
                            mode="full"
                            onClose={() => setFeaturedFlightVisibility(false)}
                        >
                            <main className="feature-flight-modal">
                                <header className="header-modal">
                                    <span>{renderDisplayTitle(featuredFlights[featuredFlightIndex])} </span>
                                </header>
                                <article className="article-modal">
                                    <WeeklyFlightAvailability
                                        route={{
                                            origin: featuredFlights[featuredFlightIndex].code?.code.split("-")[0],
                                            destination: featuredFlights[featuredFlightIndex].code?.code.split("-")[1],
                                            weekSchedule: featuredFlights[featuredFlightIndex].weekSchedule
                                        }}
                                        destinationVisiblity={false}
                                        onDayAvailabilityClick={(departureDate: number) => onDayAvailabilityClick(departureDate, featuredFlights[featuredFlightIndex])}
                                    />
                                </article>
                                <section className="bottom-container">
                                    <Button
                                        text={tr("btn_reserve")}
                                        height="35px"
                                        variant="contained"
                                        color="secondary"
                                        onClick={() => onReserveClick(featuredFlights[featuredFlightIndex])}
                                    />
                                    <Button
                                        text={tr("trip_information")}
                                        height="35px"
                                        variant="outlined"
                                        color="secondary"
                                        url={`${Path?.Destinations}/${featuredFlights[featuredFlightIndex].code?.code.split("-")[1]}?baseCity=${baseCityCode}`}
                                    />
                                </section>
                            </main>
                        </Modal>
                    </>
                    : ""
            }

        </div >
    )
}

export const setFirstAvailableDate = (weekSchedule: IWeekSchedule = {}, defaultDateTime?: number): number => {
    const locale = Culture.getLocale();
    const date = Culture.getDateTimeInstance();
    if (defaultDateTime)
        date.setTime(defaultDateTime);
    // Set active days for departure route
    const weekDays: string[] = locale.weekDays.map(wd => wd.day.toLocaleLowerCase());
    let addedDay: number = 0;
    const selectedWeekDay = weekDays.findIndex(wd => {
        const wdIndex = weekDays.findIndex(x => x === wd);
        return ((weekSchedule[wd as keyof IWeekSchedule] || 0) > 0) && (defaultDateTime ? wdIndex > date.getDay() : wdIndex >= date.getDay())
    });
    if (selectedWeekDay !== -1)
        addedDay = selectedWeekDay - date.getDay();
    else
        addedDay = 7 - (date.getDay() - weekDays.findIndex(wd => (weekSchedule[wd as keyof IWeekSchedule] || 0) > 0));
    date.setTime(date.getTime() + (addedDay * DateInMilliSec.dayPerMilliSeconds));
    return date.getTime();
}

export const friendlyWeekSchedule = (weekSchedule: IWeekSchedule = {}): string => {
    const { tr } = Translate;
    const locale = Culture.getLocale();
    let activeDays: { day: string; count: number }[] = [];
    for (const day in weekSchedule) {
        const count = weekSchedule[day as keyof IWeekSchedule] || 0;
        if (count > 0)
            activeDays.push({ day, count });
    }
    const totalFlights = activeDays.reduce(function (prev, ad) {
        return prev + ad.count;
    }, 0);

    switch (activeDays.length) {
        case 7: // All days in week
            return tr("featured_flights_all_days_in_week", totalFlights);
        case 6: // 6 Day in week
            return tr("featured_flights_all_days_except_one_day", locale.weekDays.filter(wd => !activeDays.find(ad => ad.day === wd.day.toLowerCase())).map(x => x.displayText));
        default: // lower then 6 days in week
            return locale.weekDays.filter(wd => activeDays.find(ad => ad.day === wd.day.toLowerCase())).map(x => x.displayText).join(`${locale.sep} `);
    }
}

export const totalWeeklyFlights = (weekSchedule: IWeekSchedule = {}): number => {
    let activeDays: number[] = [];
    for (const day in weekSchedule) {
        const count = weekSchedule[day as keyof IWeekSchedule] || 0;
        if (count > 0)
            activeDays.push(count);
    }
    return activeDays.reduce(function (prev, ad) {
        return prev + ad;
    }, 0);
}
export default FeaturedFlights;
